function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "currentColor",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M9.606 16.7l2.12 2.12h3.44c.419 0 .756-.34.756-.756v-7.946l-6.316 6.32a.182.182 0 000 .263zM4.21 7.866v3.44l2.12 2.12a.182.182 0 00.263 0l6.32-6.32H4.967a.76.76 0 00-.757.76z"
}), React.createElement("path", {
  d: "M12.165 4.014c.329-.498.881-.8 1.477-.8h5.438c.428 0 .776.349.776.776v5.443c0 .591-.297 1.148-.795 1.473l-7.805 5.106a.67.67 0 01-.839-.087l-3.268-3.267a.67.67 0 01-.086-.839l5.102-7.805zm3.776 4.983a1.944 1.944 0 100-3.887 1.944 1.944 0 000 3.887zm-3.479.66l-4.156 4.157.959.958 4.156-4.156-.959-.958zM5.359 17.748v-2.759H4.21v3.848h3.907v-1.09z"
}));

var SvgServiceLogoAzureIcon = function SvgServiceLogoAzureIcon(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgServiceLogoAzureIcon;